export default __webpack_public_path__ + "static/4_25-9f3078ab3461c6124e13758c41e8e8e8.png";